export const breadBrumbs = {
    questionnarie: 'Cuestionarios',
    settingFolios: 'Configuración general',
    programmedReport: 'Reporte de programaciones',
    programationByAreaAndDepartment: 'Reporte por área y departamento',
    progressQuestionnaireByUnitys: 'Avance de cuestionarios',
    'area-chart' : 'Áreas',
    'departments-chart' :'Departamentos',
    'usersRegister': 'Usuarios',
    'userType-register': 'Tipos de usuarios',
    storeDivision: 'Divisiones',
    storeZone: 'Zonas',
    storeUnity: 'Unidades',
    questionnarieMain: 'Cuestionarios',
    filesManager : 'Repositorio de archivos',
    filesManagerDetail: 'Detalle de archivo',
    filesManagerEdit: 'Edición de archivo',
    logbook: 'Bitácora',
    settingAdmins: 'Administradores',
    settingCompanies: 'Compañías',
    settingOptionGroup: 'Grupo de opciones',
    editOptionGroup : 'Editar grupo de opciones',
    createOptionGroup : 'Nuevo grupo de opciones',
    localizationMain: 'Localización',
    previewEdit: 'Detalle',
    permission: 'Permisología',
    permissionEdit: 'Permisología',
    editEdit: 'Editar cuestionario',
    headerEdit: 'Editar cuestionario',
    'action-plan': 'Planes de acción',
    'action-planEdit': 'Detalle de plan de acción',
    header: 'Nuevo cuestionario',
    calendar: 'Agenda',
    detailEdit: 'Detalle',
    scheduleDetail: 'Detalle de visita',
    scheduleList: 'Listado de cuestionarios',
    recurrenceEdit: 'Detalle de alerta de reincidencia',
    schedule: 'Agenda',
    'user-schedule': 'Agenda de usuarios',
    'schedule-user': 'Agenda de usuarios',
    'report-folio-list': 'Listado de folios de reporte',
    reportFolioList: 'Listado de folios de reporte',
    maintenanceRequest: "Listado de folios",
    'report-folioEdit': 'Detalle de folio de reporte',
    executeDetail: 'Detalle de ejecución del cuestionario',
    executionEdit: 'Detalle de ejecución',
    recurrence: 'Reincidencias',
    reportFolio: 'Reporte de folio',
    'organization-chart': '',
    departments: 'Departamento',
    userSchedule: 'Agenda de usuarios',
    editDepartment: 'Edición de departamento',
    createDepartment: 'Creación de departamento',
    'area-department': 'Áreas y departamentos',
    'time-config': 'Niveles de servicios',
    timeConfigCreate: 'Configuración niveles de servicios',
    createCatalog: 'Nuevo catálogo',
    editCatalog: 'Edición de catálogo',
    catalog: 'Configuración de catálogos',
    detailReportFolio: 'Detalle de folio',
    'NewRequest': 'Nueva solicitud',
    'correctivoEdit': 'Edición de la solicitud',
    'preventivoEdit': 'Edición de la solicitud',
    'reassign-userEdit': 'Reasignar folio',
    'area-department-config': 'Asociación de catálogos',
    'area-department-create': 'Nuevo catálogo',
    'area-department-edit': 'Edición de catálogo',
    notification: 'Centro de notificaciones',
    deleteActivity: 'Eliminar actividad',
    assignActivity: 'Asignar actividad',
    editAcivity: 'Editar actividad',
    dropList: 'Listas desplegables'
}